export function urlJoin(urlSegments: string[]): string {
    const removePostSlash = (s: string) => s.replace(/\/+$/, "");
    const removePreSlash = (s: string) => s.replace(/^\/+/, "");
    const joiner = (pre: string, cur: string) => [removePostSlash(pre), removePreSlash(cur)].join("/");
    const parts = Array.prototype.slice.call(urlSegments);
    return parts.reduce(joiner);
};